module.exports = __webpack_public_path__ + "static/fonts/DingTalk-JinBuTi.f059c1c.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DingTalk-JinBuTi.ttf
// module id = FXqN
// module chunks = 46